import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { MyIcon } from '../../common/baseConfig';
import { Collapse, Button, message } from 'antd';
import shallowequal from 'shallowequal';

const Panel = Collapse.Panel;

export class StartExerChapter extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    chapterID: -1,
    chapterList: [],
    chapterName: '',
    chapterRange: 0, //chapterRange 0表示所有 1已做 2未做 3错题
    chapterType: new Set([1]),
    chapterCount: 5,
    quesType: null, //试题类型数据
    quesCount: 0, //试题类型所有的数量
    mode: 0, // 0:选择版本题目列表模式 1:选择题目类型数量
    chapterId: 0,
    selectCount: [], //默认可供选择数量
  };
  componentDidMount() {
    //初始化
    const { fetchGetQuestionStoreSelect } = this.props.center;
    if (fetchGetQuestionStoreSelect) {
      let QuestionStore_ID = fetchGetQuestionStoreSelect.storeID;
      this.props.actions.fetchGetChapter({ QuestionStore_ID });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      !shallowequal(
        this.props.center.fetchGetQuestionStoreSelect,
        nextProps.center.fetchGetQuestionStoreSelect,
      )
    ) {
      const { fetchGetQuestionStoreSelect } = nextProps.center;
      let QuestionStore_ID = fetchGetQuestionStoreSelect.storeID;
      this.setState(
        {
          chapterID: -1,
          chapterList: [],
        },
        () => {
          this.props.actions.fetchGetChapter({ QuestionStore_ID });
          // this.props.actions.fetchGetChapterPraticeType({
          //   PraticeType: this.state.chapterRange,
          //   storeId: QuestionStore_ID,
          // });
        },
      );
    }
  }
  updateQues(Data) {
    let count = 0,
      newArr = [];
    Data.forEach(item => {
      count += item.QsCount;
    });
    if (count > 0) newArr.push(5);
    if (count > 5) newArr.push(10);
    if (count > 10) newArr.push(15);
    if (count > 15) newArr.push(20);
    if (count > 20) newArr.push(25);
    if (count > 25) newArr.push(30);
    this.setState({
      quesType: Data,
      quesCount: count,
      selectCount: newArr,
    });
  }
  doExer(data) {
    if (data.QuestionCounts === 0) {
      message.warn('没有更多的试题');
      return;
    }
    const { fetchGetQuestionStoreSelect } = this.props.center;
    this.props.actions
      .fetchGetChapterPraticeInfo({
        storeId: fetchGetQuestionStoreSelect.storeID,
        chapterId: data.ID,
      })
      .then(res => {
        if (res.SuccessResponse) {
          this.updateQues(res.Data.QuestionTypeList);
        }
      });
    this.setState(
      {
        mode: 1,
        chapterName: data.Name,
        chapterId: data.ID,
      },
      () => {
        typeof this.props.setChoiceDisable === 'function' && this.props.setChoiceDisable(true);
      },
    );
  }
  getChapterName(QuestionStoreSelect) {
    let subject = JSON.parse(localStorage.getItem('subject'));
    return `${subject.subjectName}-${QuestionStoreSelect.storeName} ${this.state.chapterName}`;
  }
  onRangeClick(range) {
    this.setState(
      {
        chapterRange: range,
      },
      () => {
        this.props.actions
          .fetchGetChapterPraticeType({
            PraticeType: this.state.chapterRange,
            storeId: this.props.center.fetchGetQuestionStoreSelect.storeID,
            chapterId: this.state.chapterId,
          })
          .then(res => {
            if (res.SuccessResponse) {
              this.updateQues(res.Data);
            }
          });
      },
    );
  }
  onTypeClick(type) {
    let { chapterType } = this.state;
    if (type === 0) {
      //所有
      if (chapterType.size === 6) {
        chapterType = new Set();
      } else {
        chapterType = new Set([1, 2, 3, 4, 5, 6]);
      }
    } else {
      if (chapterType.has(type)) {
        chapterType.delete(type);
      } else {
        chapterType.add(type);
      }
    }
    this.setState({
      chapterType,
    });
  }
  onCountClick(count) {
    this.setState({
      chapterCount: count,
    });
  }
  onGetExercise(ExamType) {
    const { chapterType, chapterId, chapterCount, chapterRange, selectCount } = this.state;
    console.log(chapterRange);
    const { fetchGetQuestionStoreSelect } = this.props.center;
    let questionType = '';
    if (chapterType.size === 0) {
      message.warn('请选择至少一种试题类型');
      return;
    }
    for (const iterator of chapterType) {
      questionType += iterator + ',';
    }
    questionType = questionType.slice(0, questionType.length - 1);
    const data = {
      ExamType: ExamType,
      chapterId: chapterId,
      questionCount: chapterCount,
      questionSource: chapterRange,
      questionType: questionType,
      storeId: fetchGetQuestionStoreSelect.storeID,
    };
    if (selectCount.length > 0) {
      if (ExamType === 1) {
        //练习模式
        localStorage.setItem('chapterPracConfig', JSON.stringify(data));
        this.props.history.push('/ques/chapter/prac');
      } else {
        localStorage.setItem('chapterExamConfig', JSON.stringify(data));
        this.props.history.push('/ques/chapter/exam');
      }
    } else {
      message.warn('没有更多的试题');
    }

    // this.props.actions.fetchQuesCreateChapter(data).then(res => {
    //   if (res.SuccessResponse) {

    //   }
    // });
  }
  render() {
    const {
      fetchGetChapterSuccess,
      fetchGetQuestionStoreSelect,
      fetchGetChapterPraticeInfoSuccess,
    } = this.props.center;

    let {
      chapterID,
      chapterList,
      mode,
      chapterRange,
      chapterType,
      chapterCount,
      quesType,
      quesCount,
      selectCount,
    } = this.state;

    if (
      fetchGetChapterSuccess &&
      fetchGetChapterSuccess.length > 0 &&
      chapterID === -1 &&
      chapterList.length === 0
    ) {
      chapterID = fetchGetChapterSuccess[0].ID;
      chapterList = fetchGetChapterSuccess[0].ChapterList;
    }

    const header = (item, isSecond) => {
      return (
        <div className="header">
          <h2>{item.Name}</h2>
          <div className="extra">
            <p>
              {item.AlreadyCounts}/{item.QuestionCounts}
            </p>
            <Button
              type={isSecond ? 'theme2' : 'theme'}
              className="doExerBtn"
              onClick={e => {
                e.stopPropagation();
                this.doExer(item);
              }}
            >
              做题
            </Button>
          </div>
        </div>
      );
    };
    return (
      <div className="center-start-exer-chapter">
        {mode === 0 && fetchGetChapterSuccess && (
          <div className="inner">
            <h1>
              {fetchGetChapterSuccess.length > 0 &&
                fetchGetChapterSuccess.map(item => (
                  <div
                    key={item.ID}
                    className={chapterID === item.ID ? 'versionItem-active' : 'versionItem'}
                    onClick={() => {
                      this.setState({
                        chapterID: item.ID,
                        chapterList: item.ChapterList,
                      });
                    }}
                  >
                    {item.Name}
                  </div>
                ))}
            </h1>
            {chapterList.length > 0 && (
              <Collapse
                defaultActiveKey={['0']}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <MyIcon type="iconshouqi" className="expandIcon" />
                  ) : (
                    <MyIcon type="iconzhankai" className="expandIcon" />
                  )
                }
              >
                {chapterList.map((item, index) => (
                  <Panel header={header(item, false)} key={index}>
                    {item.Children && (
                      <Collapse
                        className="secondCollapse"
                        expandIcon={({ isActive }) =>
                          isActive ? (
                            <MyIcon type="iconshouqi" className="expandIcon" />
                          ) : (
                            <MyIcon type="iconzhankai" className="expandIcon" />
                          )
                        }
                      >
                        {item.Children.map((it, i) => (
                          <Panel header={header(it, true)} key={i}>
                            {it.Children && (
                              <div className="third">
                                {it.Children.map(ele => (
                                  <div key={ele.ID} className="third-item">
                                    <h3>{ele.Name}</h3>
                                    <div className="extra">
                                      <p>
                                        {ele.AlreadyCounts}/{ele.QuestionCounts}
                                      </p>
                                      <Button
                                        type="theme2"
                                        className="doExerBtn"
                                        onClick={e => {
                                          e.stopPropagation();
                                          this.doExer(ele);
                                        }}
                                      >
                                        做题
                                      </Button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </Panel>
                        ))}
                      </Collapse>
                    )}
                  </Panel>
                ))}
              </Collapse>
            )}
          </div>
        )}
        {mode === 1 && (
          <div className="inner">
            <h4>
              <p>{this.getChapterName(fetchGetQuestionStoreSelect)}</p>
              <p
                onClick={() => {
                  this.setState(
                    {
                      mode: 0,
                    },
                    () => {
                      typeof this.props.setChoiceDisable === 'function' &&
                        this.props.setChoiceDisable(false);
                    },
                  );
                }}
              >
                返回列表
              </p>
            </h4>
            <div className="chapter-radios">
              <div className="chapter-radio">
                <p>试题范围:</p>
                <ul className="range">
                  <li
                    data-count={
                      fetchGetChapterPraticeInfoSuccess &&
                      fetchGetChapterPraticeInfoSuccess.ChapterPracticeModelList[0].TotalCount
                    }
                    className={chapterRange === 0 ? 'item-active' : 'item'}
                    onClick={this.onRangeClick.bind(this, 0)}
                  >
                    所有
                  </li>
                  <li
                    data-count={
                      fetchGetChapterPraticeInfoSuccess &&
                      fetchGetChapterPraticeInfoSuccess.ChapterPracticeModelList[0].YetCount
                    }
                    className={chapterRange === 2 ? 'item-active' : 'item'}
                    onClick={this.onRangeClick.bind(this, 2)}
                  >
                    未做试题
                  </li>
                  <li
                    data-count={
                      fetchGetChapterPraticeInfoSuccess &&
                      fetchGetChapterPraticeInfoSuccess.ChapterPracticeModelList[0].AlreadyCount
                    }
                    className={chapterRange === 1 ? 'item-active' : 'item'}
                    onClick={this.onRangeClick.bind(this, 1)}
                  >
                    已做试题
                  </li>
                  <li
                    data-count={
                      fetchGetChapterPraticeInfoSuccess &&
                      fetchGetChapterPraticeInfoSuccess.ChapterPracticeModelList[0].WrongCount
                    }
                    className={chapterRange === 3 ? 'item-active' : 'item'}
                    onClick={this.onRangeClick.bind(this, 3)}
                  >
                    错误试题
                  </li>
                </ul>
              </div>
              <div className="chapter-radio">
                <p>试题类型:</p>
                {quesType && (
                  <ul style={{ width: 500 }} className="type">
                    <li
                      data-count={quesCount}
                      className={chapterType.size === 6 ? 'item-active' : 'item'}
                      onClick={this.onTypeClick.bind(this, 0)}
                    >
                      所有
                    </li>
                    {quesType.map(item => (
                      <li
                        key={item.ID}
                        data-count={item.QsCount}
                        className={chapterType.has(item.ID) ? 'item-active' : 'item'}
                        onClick={this.onTypeClick.bind(this, item.ID)}
                      >
                        {item.Name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="chapter-radio">
                <p>试题数量:</p>
                <ul>
                  {selectCount.map(item => (
                    <li
                      key={item}
                      className={chapterCount === item ? 'small-item-active' : 'small-item'}
                      onClick={this.onCountClick.bind(this, item)}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="chapter-btns">
                <Button type="theme" onClick={() => this.onGetExercise(1)} className="practiceBtn">
                  练习模式
                </Button>
                <Button type="yellow" onClick={() => this.onGetExercise(2)} className="examBtn">
                  考试模式
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StartExerChapter);



// WEBPACK FOOTER //
// ./src/features/center/StartExerChapter.js